import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {SessionService} from '../../@core/session.service';
import {ActivatedRoute} from '@angular/router';

import { NzButtonComponent } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    imports: [NzButtonComponent]
})
export class SignInComponent implements OnInit {

  ssoUrl = `${environment.ssoUrl}?r=${window.location.href}/`;

  constructor(private actRoute: ActivatedRoute, private sess: SessionService) {
  }

  ngOnInit(): void {
    const {redirect, token} = this.actRoute.snapshot.params;
    if (token) {
      this.sess.ssoSignIn(token, redirect ? redirect.split('~') : ['menu']);
    }
  }

}
